/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2MedicalHistoryTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2MedicalHistoryTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2MedicalHistoryTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 19,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#7A0C2B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2MedicalHistoryTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 19 18"
 style={{'--as-1-Z2ralcJ': alignSelf,'--mt-2-Z2ralcJ': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2ralcJ': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2ralcJ': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2ralcJ': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2ralcJ': opacity,'--w-10-Z2ralcJ': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2ralcJ': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2ralcJ': fill,'--a-7-Z2ralcJ': isAnimated ? animation : "none",'--sd-8-Z2ralcJ': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2ralcJ': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2MedicalHistoryTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.977 0C.885 0 0 .87 0 1.943v10.118c0 1.073.885 1.943 1.977 1.943h5.465L6.716 16H5.429a1.01 1.01 0 00-1.018 1c0 .553.455 1.001 1.018 1.001h8.142a1.01 1.01 0 001.018-1c0-.553-.455-1-1.018-1h-1.285l-.727-1.996h5.464c1.092 0 1.977-.87 1.977-1.943V1.943C19 .87 18.115 0 17.023 0H1.977zm6.15 3.548c0-.29.238-.524.532-.524h1.73c.294 0 .533.235.533.524v2.08h2.117c.294 0 .533.235.533.524v1.7a.528.528 0 01-.533.524h-2.117v2.08a.528.528 0 01-.533.524H8.66a.528.528 0 01-.533-.524v-2.08H6.01a.528.528 0 01-.533-.524v-1.7c0-.29.239-.523.533-.523h2.117V3.548z"
 style={{'--f-12-Z2ralcJ': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}